(() => {
  'use strict';

  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  let queued = false;

  const canonicalDelivery = 'Kartenprodukte werden in der Regel innerhalb von 2–4 Werktagen nach finaler Designfreigabe bzw. nach Eingang druckfähiger Daten geliefert. Verfügbare Kunden-Übergabe Bundles benötigen in der Regel 2–7 Werktage nach Bestelleingang. Nicht lagernde oder personalisierte Bundles benötigen in der Regel etwa 10–14 Werktage; bei personalisierten Bundles zählt die Zeit ab finaler Freigabe.';
  const canonicalDesignService = 'Der Design-Service kostet 20 € netto für ein Kartenprodukt und 30 € netto für zwei Kartenprodukte. Beim Kauf aller drei Kartenprodukte – Dankeskarte, Pflegehinweis und Visitenkarte – ist der Design-Service kostenlos enthalten.';
  const canonicalColors = 'Bei Kunden-Bundles wählen Sie Format und Farbe direkt auf der Produktseite. Wenn Sie mehrere Farben kombinieren möchten, aktivieren Sie „Farben mischen“ und verteilen die gewünschte Stückzahl auf die verfügbaren Farben. Die Verfügbarkeit wird bei der Auswahl berücksichtigt.';

  function setText(el, text) {
    if (el && clean(el.textContent) !== clean(text)) el.textContent = text;
  }

  function setHtml(el, html) {
    if (el && clean(el.innerHTML) !== clean(html)) el.innerHTML = html;
  }

  function fixLinks() {
    const map = {
      '/pages/so-funktioniert': '/pages/so-funktionierts',
      '/pages/so-funktioniert-s': '/pages/so-funktionierts',
      '/pages/partnerprogramm': '/pages/partner',
      '/pages/versand-lieferung': '/pages/versand-bearbeitung',
      '/products/dynoco-kunden-uebergabe-bundle-alt': '/products/dynoco-kunden-uebergabe-bundle'
    };

    document.querySelectorAll('a[href]').forEach((link) => {
      const href = link.getAttribute('href');
      if (!href || /^https?:\/\//i.test(href)) return;
      const hashIndex = href.indexOf('#');
      const queryIndex = href.indexOf('?');
      let cut = href.length;
      if (hashIndex >= 0) cut = Math.min(cut, hashIndex);
      if (queryIndex >= 0) cut = Math.min(cut, queryIndex);
      const path = href.slice(0, cut);
      if (!map[path]) return;
      link.setAttribute('href', map[path] + href.slice(cut));
    });
  }

  function fixAnnouncement() {
    const text = document.querySelector('.dynoco-announcement__text');
    if (!text) return;
    const html = 'Für personalisierte Produkte: <strong>Designfreigabe vor Druck inklusive</strong>';
    if (clean(text.innerHTML) !== clean(html)) text.innerHTML = html;
  }

  function fixHomepageSampleMessaging() {
    const heroCard = document.querySelector('.dynoco-hero__trust-card--highlight');
    if (heroCard) {
      setText(heroCard.querySelector('strong'), 'Ab 10 Übergaben');
      setText(heroCard.querySelector('span'), 'Einstieg ab 159,99 € netto');
    }

    const value = document.querySelector('.dynoco-value');
    if (!value) return;
    setText(value.querySelector('.dynoco-value__eyebrow'), 'B2B-Preisübersicht');
    setText(value.querySelector('.dynoco-value__heading'), 'Übergabe-Bundles ab ca. 13,50 € pro Kunde');
    setText(value.querySelector('.dynoco-value__text'), 'Starten Sie mit 10 Übergaben oder wählen Sie eine größere Mengenstaffel für einen besseren Stückpreis. A4 und A5 sind ohne Format-Aufpreis erhältlich.');

    const firstCard = value.querySelector('.dynoco-price-card');
    if (firstCard) {
      firstCard.classList.remove('dynoco-price-card--sample');
      setText(firstCard.querySelector('.dynoco-price-card__badge'), 'Klein starten');
      setText(firstCard.querySelector('.dynoco-price-card__title'), '10 Übergaben');
      setText(firstCard.querySelector('.dynoco-price-card__approx'), 'ca.');
      setText(firstCard.querySelector('.dynoco-price-card__price'), '16,00 €');
      setText(firstCard.querySelector('.dynoco-price-card__unit'), 'pro Kundenübergabe');
      setText(firstCard.querySelector('.dynoco-price-card__saving'), 'Für kleinere Betriebe oder zum Einstieg.');
    }
  }

  function questionText(details) {
    const summary = details.querySelector('summary');
    return clean(summary?.textContent).replace(/\+$/, '').trim().toLowerCase();
  }

  function setDetailsAnswer(details, text) {
    const answer = details.querySelector('.dynoco-faq__answer');
    if (answer) {
      setHtml(answer, '<p>' + text + '</p>');
      return;
    }
    const directParagraph = Array.from(details.children).find((node) => node.tagName === 'P');
    if (directParagraph) setText(directParagraph, text);
  }

  function fixFaqs() {
    document.querySelectorAll('details').forEach((details) => {
      const question = questionText(details);
      if (!question) return;
      if (question.includes('wie viel kostet der design-service')) {
        setDetailsAnswer(details, canonicalDesignService);
      } else if (question.includes('wie lange') && (question.includes('liefer') || question.includes('bearbeit'))) {
        setDetailsAnswer(details, canonicalDelivery);
      } else if (question.includes('farben für zubehör') || question.includes('farben') && question.includes('auswählen')) {
        setDetailsAnswer(details, canonicalColors);
      }
    });
  }

  function fixCart() {
    const cart = document.querySelector('.dynoco-cart-info');
    if (!cart) return;
    setText(cart.querySelector('.dynoco-cart-info__main p'), 'Bei Standard-Bundles sind keine zusätzlichen Design-Daten erforderlich. Bei personalisierten Produkten teilen Sie uns nach der Bestellung Logo und gewünschte Inhalte mit.');

    const cards = Array.from(cart.querySelectorAll('.dynoco-cart-info__card'));
    if (cards[0]) {
      setText(cards[0].querySelector('h3'), 'Bestellung prüfen');
      setText(cards[0].querySelector('p'), 'Wir prüfen Produkt, Variante und Verfügbarkeit. Bei Standard-Bundles können wir anschließend direkt mit der Bearbeitung starten.');
    }
    if (cards[1]) {
      setText(cards[1].querySelector('h3'), 'Daten nur bei Personalisierung');
      setText(cards[1].querySelector('p'), 'Bei personalisierten Karten oder Bundles senden Sie uns Logo, Texte und ggf. QR-Code bzw. Druckdateien. Der Druck startet erst nach Ihrer Freigabe.');
    }
    if (cards[2]) {
      setText(cards[2].querySelector('h3'), 'Produktion & Versand');
      setText(cards[2].querySelector('p'), 'Karten: 2–4 Werktage nach Freigabe bzw. druckfähigen Daten. Verfügbare Bundles: 2–7 Werktage. Personalisierte oder nicht lagernde Bundles: in der Regel 10–14 Werktage.');
    }
  }

  function fixShippingPage() {
    document.querySelectorAll('.dynoco-shipping-time-card').forEach((card) => {
      const title = clean(card.querySelector('h3')?.textContent).toLowerCase();
      const strong = card.querySelector('strong');
      const p = card.querySelector('p');
      if (title.includes('kartenprodukte')) {
        setText(strong, '2–4 Werktage');
        setText(p, 'Nach finaler Designfreigabe oder nach Eingang druckfähiger Daten.');
      } else if (title.includes('kunden-übergabe')) {
        setText(strong, '2–7 Werktage');
        setText(p, 'Für verfügbare Standard-Bundles nach Bestelleingang. Nicht lagernde Varianten benötigen in der Regel etwa 10–14 Werktage.');
      } else if (title.includes('vorbestellungen')) {
        setText(strong, '10–14 Werktage');
        setText(p, 'Für nicht lagernde Varianten und größere Mengen. Die voraussichtliche Lieferzeit wird bei der Bestellung berücksichtigt.');
      } else if (title.includes('kombibestellungen')) {
        setText(strong, 'Je nach längstem Produkt');
        setText(p, 'Bei Kombibestellungen richtet sich die Lieferzeit nach dem Produkt mit der längsten Bearbeitungszeit.');
      }
    });

    const infoBoxes = document.querySelectorAll('.dynoco-shipping-info__box');
    infoBoxes.forEach((box) => {
      const title = clean(box.querySelector('h2')?.textContent).toLowerCase();
      if (!title.includes('wichtig zur lieferzeit')) return;
      const paragraphs = box.querySelectorAll('p');
      if (paragraphs[0]) setText(paragraphs[0], 'Bei verfügbaren Standard-Bundles beginnt die Lieferzeit mit dem Bestelleingang. Bei personalisierten Produkten beginnt sie, sobald alle benötigten Daten vollständig vorliegen und die finale Designfreigabe erfolgt ist.');
      if (paragraphs[1]) setText(paragraphs[1], 'Verzögerungen können entstehen, wenn Daten fehlen, Rückfragen offen sind oder eine Variante aktuell nicht lagernd ist.');
    });
  }

  function fixProcessSteps() {
    const text = 'Nach der Freigabe starten Produktion und Versand. Karten benötigen in der Regel 2–4 Werktage. Verfügbare Standard-Bundles benötigen 2–7 Werktage; personalisierte oder nicht lagernde Bundles in der Regel etwa 10–14 Werktage.';
    document.querySelectorAll('.dynoco-step, .dynoco-process-card').forEach((card) => {
      const heading = clean(card.querySelector('h3')?.textContent).toLowerCase();
      if (heading === 'druck & versand') setText(card.querySelector('p'), text);
    });
  }

  function fixVisibleTypo() {
    document.querySelectorAll('.variant-option__button-label').forEach((label) => {
      const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        if (node.nodeValue && node.nodeValue.includes('Gläzend')) node.nodeValue = node.nodeValue.replaceAll('Gläzend', 'Glänzend');
      });
    });
    document.querySelectorAll('option[value="Gläzend"]').forEach((option) => {
      if (option.textContent.includes('Gläzend')) option.textContent = option.textContent.replaceAll('Gläzend', 'Glänzend');
    });
  }

  function markLegacyPages() {
    const path = window.location.pathname.replace(/\/$/, '');
    const canonicalMap = {
      '/pages/uber-dynoco': '/pages/ueber-dynoco',
      '/pages/versand-lieferung': '/pages/versand-bearbeitung'
    };
    const canonicalPath = canonicalMap[path];
    if (!canonicalPath) return;

    let canonical = document.querySelector('link[rel="canonical"][data-dynoco-fix]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.dataset.dynocoFix = 'true';
      document.head.appendChild(canonical);
    }
    canonical.href = window.location.origin + canonicalPath;

    let robots = document.querySelector('meta[name="robots"][data-dynoco-fix]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      robots.dataset.dynocoFix = 'true';
      document.head.appendChild(robots);
    }
    robots.content = 'noindex,follow';
  }

  function hideLegacyBundleMedia() {
    const path = window.location.pathname.replace(/\/$/, '');
    if (path !== '/products/dynoco-kunden-uebergabe-bundle') return;
    document.querySelectorAll('img[src*="ChatGPT_Image_6._Juli_2026_20_44_31"]').forEach((img) => {
      const wrapper = img.closest('[data-media-id], .product-media-container, .product-media, li, slideshow-slide');
      if (wrapper) wrapper.style.display = 'none';
      else img.style.display = 'none';
    });
  }

  function ensureSpacing() {
    if (document.getElementById('dynoco-v17-audit-spacing')) return;
    const style = document.createElement('style');
    style.id = 'dynoco-v17-audit-spacing';
    style.textContent = 'dynoco-bundle-color-mix,dynoco-bundle-color-mix-personalized{display:block;margin-bottom:20px}';
    document.head.appendChild(style);
  }

  function applyFixes() {
    queued = false;
    fixLinks();
    fixAnnouncement();
    fixHomepageSampleMessaging();
    fixFaqs();
    fixCart();
    fixShippingPage();
    fixProcessSteps();
    fixVisibleTypo();
    markLegacyPages();
    hideLegacyBundleMedia();
    ensureSpacing();
  }

  function scheduleFixes() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(applyFixes);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyFixes, { once: true });
  else applyFixes();

  new MutationObserver(scheduleFixes).observe(document.documentElement, { childList: true, subtree: true });
})();
